import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types.ts";

const pathBase = `/roles/:userId/:role/`;

export type IPathBaseParams = IExtractApiParams<typeof pathBase>;

export const roleManagement = {
  get: (params: IPathBaseParams) => generateApiPath(pathBase, params),
  post: (params: IPathBaseParams) => generateApiPath(pathBase, params),
};
